import { FormattedMessage, FormattedNumber } from 'react-intl'

import { IconCrownUpgrade, IconQuestionMarkCircle } from '@gto/ui/assets'
import { Badge } from '@gto/ui/badge'
import { Paper } from '@gto/ui/paper'
import { Tooltip } from '@gto/ui/tooltip'
import { Typography } from '@gto/ui/typography'

export type EdgeMultiplierCardProps = {
  multiplier?: string | null
  site?: string | null
}

export const EdgeMultiplierCard = ({ multiplier = '0', site }: EdgeMultiplierCardProps) => {
  return (
    <Paper className="flex-none rounded-md border-2 border-primary-main bg-black p-4 sm:w-full">
      <div className="flex flex-col items-center justify-between gap-2 sm:flex-row">
        <Badge
          className="gap-1"
          color="info"
          variant="default"
        >
          <IconCrownUpgrade
            color="inherit"
            height={12}
          />
          <FormattedMessage id="home.dealsSection.edgeMultiplier.exclusive" />
        </Badge>
        <div className="flex items-center gap-1.5">
          <div className="flex flex-col items-center sm:flex-row sm:gap-1.5">
            {/* CoinPoker specific message due to some specifics, slug is unique and provided from API */}
            {site === 'coinpoker' && (
              <Typography
                className="font-semibold leading-[1] text-[#84FFFF]"
                variant="subtitle1"
              >
                <FormattedMessage id="home.dealsSection.edgeMultiplier.upTo" />
              </Typography>
            )}
            <Typography
              className="font-semibold text-[#84FFFF]"
              variant="h5"
            >
              <FormattedNumber
                signDisplay="always"
                style="percent"
                value={typeof multiplier === 'number' ? multiplier / 100 : Number(multiplier) / 100}
              />
            </Typography>
          </div>
          <Typography
            className="whitespace-pre-wrap leading-[1]"
            variant="subtitle3"
          >
            <FormattedMessage id="home.dealsSection.edgeMultiplier.bonusRewards" />
          </Typography>
          <div className="ml-1 flex cursor-pointer items-center justify-center text-text-secondary transition-colors duration-300 hover:text-primary-main">
            <Tooltip
              content={<FormattedMessage id="home.dealsSection.edgeMultiplier.tip" />}
              placement="top"
            >
              <IconQuestionMarkCircle
                height={24}
                width={24}
              />
            </Tooltip>
          </div>
        </div>
      </div>
    </Paper>
  )
}
